import {FC, useEffect, useState} from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../../_metronic/helpers'
import ReactApexChart from 'react-apexcharts'
import moment from 'moment-timezone'
import DatePicker from 'react-datepicker'
import {useDispatch, useSelector} from 'react-redux'
import Select from 'react-select'
import {
  GetLeadGenrationReport,
  GetOverAllReportCount,
  GetOverAllReportData,
  getAllMessageReport,
  getAllReportOverview,
  getAllReportOverviewCount,
  getAllReportOverviewExport,
  getLeadGenrationData,
  getLeadGenrationExport,
} from './reportSlices/reportAnalytics'
import NodataYet from '../../../Components/NodataYet'
import { ENV } from '../../../Utils/_helpers/EnvHelper'

const ReportsAnalyticsPage: FC = () => {
  const API_DOMAIN = ENV().REACT_APP_DOMAIN
  const dispatch = useDispatch()
  const today = new Date() // Current date
  const sevenDaysAgo = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000)

  const reportCount = useSelector(GetOverAllReportCount)
  const reportOverAllData = useSelector(GetOverAllReportData)
  const leadgenrationData = useSelector(GetLeadGenrationReport)
  const [campType, setCampType] = useState('sms')

  const [messageCampType, setMessageCampType] = useState('sms')
  const [ActivityGraphCampType, setActivityGraphCampType] = useState('sms')


  const [dateRange, setDateRange] = useState<any>([sevenDaysAgo, new Date()])
  const [type, setType] = useState('total')
  const [startDate, endDate] = dateRange
  const [bulkPage, setBulkPage] = useState(1)

  useEffect(() => {
    if (!dateRange?.includes(null)) {
      dispatch(
        getAllReportOverview({
          fromDate: moment(startDate).format('YYYY-MM-DD'),
          toDate: moment(endDate).format('YYYY-MM-DD'),
          camp_type: ActivityGraphCampType,
          type,
          page: bulkPage,
        })
      )
      dispatch(
        getAllReportOverviewCount({
          fromDate: moment(startDate).format('YYYY-MM-DD'),
          toDate: moment(endDate).format('YYYY-MM-DD'),
          camp_type: campType,
          type,
        })
      )

      dispatch(
        getLeadGenrationData({
          fromDate: moment(startDate).format('YYYY-MM-DD'),
          toDate: moment(endDate).format('YYYY-MM-DD'),
          camp_type: campType,
        })
      )

      dispatch(
        getAllMessageReport({
          fromDate: moment(startDate).format('YYYY-MM-DD'),
          toDate: moment(endDate).format('YYYY-MM-DD'),
          camp_type: messageCampType,
          page: bulkPage,
        })
      )
    }
  }, [dateRange])

  // Handle change in activity overview
  useEffect(() => {
    dispatch(
      getAllReportOverview({
        fromDate: moment(startDate).format('YYYY-MM-DD'),
        toDate: moment(endDate).format('YYYY-MM-DD'),
        camp_type: ActivityGraphCampType,
        type,
        page: bulkPage,
      })
    )
  }, [ActivityGraphCampType, type])


  // Handle change in activity overview
  useEffect(() => {
    dispatch(
      getAllReportOverview({
        fromDate: moment(startDate).format('YYYY-MM-DD'),
        toDate: moment(endDate).format('YYYY-MM-DD'),
        camp_type: ActivityGraphCampType,
        type,
        page: bulkPage,
      })
    )
  }, [ActivityGraphCampType, type])

  // All Bulk Messages
  useEffect(() => {
    dispatch(
      getAllMessageReport({
        fromDate: moment(startDate).format('YYYY-MM-DD'),
        toDate: moment(endDate).format('YYYY-MM-DD'),
        camp_type: messageCampType,
        page: bulkPage,
      })
    )
  }, [messageCampType, bulkPage])


  const handleDownloadActivityOverview = async () => {  
    const result = await dispatch(
      getAllReportOverviewExport({
        fromDate: moment(startDate).format('YYYY-MM-DD'),
        toDate: moment(endDate).format('YYYY-MM-DD'),
        camp_type: ActivityGraphCampType,
        type,
        page: bulkPage,
        isExport: true,
      })
    )

    if (getAllReportOverviewExport.fulfilled.match(result)) {
      const res = result.payload
      window.open(`${API_DOMAIN}${res.data.downloadurl}`, '_self')
    } else {
      console.error('Error:', result.error)
    }
  }

  const handleDownloadLeadGeneration = async () => {  
    const result = await dispatch(
      getLeadGenrationExport({
        fromDate: moment(startDate).format('YYYY-MM-DD'),
        toDate: moment(endDate).format('YYYY-MM-DD'),
        camp_type: ActivityGraphCampType,
        type,
        page: bulkPage,
        isExport: true,
      })
    )

    if (getLeadGenrationExport.fulfilled.match(result)) {
      const res = result.payload
      window.open(`${API_DOMAIN}${res.data.downloadurl}`, '_self')
    } else {
      console.error('Error:', result.error)
    }
  }

  const data1 =
    reportOverAllData?.length > 0
      ? reportOverAllData?.map((key: any) => moment(key?._id)?.format('MMM Do YY'))
      : []
  const data2 =
    reportOverAllData?.length > 0
      ? reportOverAllData?.map((key: any) => [new Date(key?._id).getTime(), key?.count])
      : []

  const leadData =
    leadgenrationData?.contactDataForGraph?.length > 0
      ? leadgenrationData?.contactDataForGraph?.map((key: any) => key?.count)
      : []

  const LeadLabel = leadgenrationData?.contactDataForGraph?.map(
    (key: any, index: number) => key?._id
  )
  // moment(endDate).diff(moment(startDate), 'days') > 30 &&
  // moment(endDate).diff(moment(startDate), 'days') < 365
  //   ? leadgenrationData?.contactDataForGraph?.map((key: any) => moment(key?._id).format('MMM'))
  //   : moment(endDate).diff(moment(startDate), 'days') > 365
  //   ? leadgenrationData?.contactDataForGraph?.map((key: any, index: number) => key?._id)
  //   : leadgenrationData?.contactDataForGraph?.map((key: any, index: number) =>
  //       index == 0 || index == leadgenrationData?.contactDataForGraph?.length - 1
  //         ? moment(key?._id).format('DD MMM')
  //         : ''
  //     ) || []

  const leadGenerationData: any = {
    series: [
      {
        name: 'lead generation',
        data: leadData,
      },
    ],
    options: {
      chart: {
        type: 'area',
        stacked: false,
        height: 350,
        zoom: {
          type: 'x',
          enabled: false,
          autoScaleYaxis: true,
        },
        toolbar: {
          show: false,
        },
      },
      colors: ['#13B787'],
      dataLabels: {
        enabled: false,
      },
      markers: {
        size: 0,
      },
      title: {
        text: '',
        align: 'left',
      },

      yaxis: {
        labels: {
          formatter: function (val: any) {
            return val?.toFixed(0)
          },
        },
        // title: {
        //   text: 'QTY',
        // },
      },
      xaxis: {
        categories: LeadLabel,
        labels: {
          show: true,
        },
      },

      tooltip: {
        custom: function ({series, seriesIndex, dataPointIndex, w}: any) {
          const dateLabel = leadgenrationData?.contactDataForGraph?.map((key: any) =>
            moment(key?._id).format('DD MMM')
          )

          const category = dateLabel[dataPointIndex]
          const value = series[seriesIndex][dataPointIndex]

          return (
            '<div class="custom-tooltip lead_chart_tooltip">' +
            '<span>' +
            category +
            '</span>' +
            '<span>' +
            value +
            '</span>' +
            '</div>'
          )
        },
        shared: true,
        intersect: false,
        y: {
          formatter: function (val: any, opts: any) {
            return val
          },
        },
      },
    },
  }

  const ReviewData: any = {
    series: [
      {
        name: `Qty`,
        data: data2,
      },
    ],
    options: {
      chart: {
        type: 'area',
        stacked: false,
        height: 100,
        toolbar: {
          show: false,
        },
      },
      colors: ['#7950F2'],
      dataLabels: {
        enabled: false,
      },
      markers: {
        size: 0,
      },
      title: {
        text: '',
        align: 'left',
      },
      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          inverseColors: false,
          opacityFrom: 0.5,
          opacityTo: 0,
          stops: [0, 90, 100],
        },
      },
      yaxis: {
        labels: {
          formatter: function (val: any) {
            return val?.toFixed(0)
          },
        },
        title: {
          text: 'QTY',
        },
      },
      xaxis: {
        type: 'datetime',
      },
      tooltip: {
        shared: false,
        y: {
          formatter: function (val: any) {
            return val?.toFixed(0)
          },
        },
      },
    },
  }


  return (
    <>
      <div className='ReportDatePicker mb-2'>
        <div className='ReportDateCalander' style={{position: 'relative'}}>
          <DatePicker
            selectsRange={true}
            dateFormat='MMM d, yyyy'
            className=' border-0 form-control form-control-lg form-control-solid'
            placeholderText='Pick data & time'
            onChange={(update: any) => {
              setDateRange(update)
            }}
            startDate={startDate}
            endDate={endDate}
          />
          <i
            className='fas fa-calendar absolute'
            style={{position: 'absolute', width: 'auto', right: '10px', top: '15px'}}
          ></i>
        </div>
      </div>

      <div className='card p-0 bg-transparent Analytics_chart_page'>
        <div className='row mx-n4'>
          <div className='col-md-6 px-4'>
            <div className='card p-8 py-5'>
              <div className='card-header border-0 p-0 align-items-center'>
                <h3 className='card-title align-items-start  flex-column'>
                  <span className='card-label fw-bolder fs-2 mb-1'>Lead Generation</span>
                  <span className='text-muted mt-1 fw-bold fs-7'>All your leads</span>
                </h3>
                <button type='button' onClick={() => handleDownloadLeadGeneration()} className='btn btn-light-primary'>
                  <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
                  Export
                </button>
                {/* <div className='card-toolbar align-items-start flex-column'>
                  <span
                    className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'
                    data-kt-menu-trigger='hover'
                    data-kt-menu-placement='bottom-end'
                  >
                    <i className='bi bi-three-dots fs-5'></i>
                  </span>
                </div> */}
              </div>
              <div className='card-body px-0 pt-5'>
                <div className='analytics_charts'>
                  <div className='chart_head'>
                    <div className='chart_item'>
                      <strong>
                        {' '}
                        {leadgenrationData?.totalCountData?.find(
                          (key: any) => key?._id === 'manually'
                        )?.count || 0}
                      </strong>
                      <span>Total new leads</span>
                    </div>
                    <div className='chart_item'>
                      <strong>
                        {leadgenrationData?.totalCountData?.find(
                          (key: any) => key?._id === 'manually'
                        )?.count || 0}
                      </strong>
                      <span>Manually added</span>
                    </div>
                    <div className='chart_item'>
                      <strong>0</strong>
                      <span>Via source</span>
                      <div className='badge right badge-light-success fw-bold '>
                        <span className='arrow'>
                          <KTSVG path='/media/misc/arrow-up.svg' className='' />
                        </span>
                        4.5%
                      </div>
                    </div>
                  </div>
                  {leadData?.length > 0 ? (
                    <div className='chart_body'>
                      <ReactApexChart
                        options={leadGenerationData.options}
                        series={leadGenerationData.series}
                        height={250}
                      />
                      {/* <img src={toAbsoluteUrl('/media/misc/lead-generation-chart.png')} alt='Image' /> */}
                    </div>
                  ) : (
                    <NodataYet />
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-6 px-4'>
            <div className='card p-8 py-5'>
              <div className='card-header border-0 p-0 align-items-center'>
                <h3 className='card-title align-items-start  flex-column'>
                  <span className='card-label fw-bolder fs-2 mb-1'>Reviews</span>
                  <span className='text-muted mt-1 fw-bold fs-7'>All your reviews</span>
                </h3>
                {/* <div className='card-toolbar align-items-start flex-column'>
                  <span
                    className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'
                    data-kt-menu-trigger='hover'
                    data-kt-menu-placement='bottom-end'
                  >
                    <i className='bi bi-three-dots fs-5'></i>
                  </span>
                </div> */}
              </div>
              <div className='card-body px-0 pt-5'>
                <div className='analytics_charts'>
                  <div className='chart_head'>
                    <div className='chart_item'>
                      <strong>0</strong>
                      <span>New reviews</span>
                    </div>
                    <div className='chart_item'>
                      <strong>0%</strong>
                      <span>Messages sent / reviews</span>
                    </div>
                  </div>
                  {false ? (
                    <div className='chart_body'>
                      <img src={toAbsoluteUrl('/media/misc/reviews_chart.png')} alt='review chart' />
                    </div>
                  ) : (
                    <NodataYet />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ///////////////////////////////////////////////////////////////////////////////////////////////////// */}
        <div className='row mt-8'>
          <div className='col-12'>
            <div className='card p-8 py-5 pt-8'>
              <div className='card-header border-0 p-0 align-items-start'>
                <h3 className='card-title align-items-start  flex-column'>
                  <span className='card-label fw-bolder fs-2 mb-1'>Activity overview</span>
                  <span className='text-muted mt-1 fw-bold fs-7'>See how you're progressing</span>
                </h3>
                <div className='d-flex justify-content-end gap-3'>
                  <div className='card-toolbar align-items-start'>
                  <Select
                    value={{
                      value: ActivityGraphCampType,
                      label: ActivityGraphCampType?.toUpperCase(),
                    }}
                    options={[
                      {value: 'sms', label: 'SMS'},
                      {value: 'mms', label: 'MMS'},
                    ]}
                    onChange={(e: any) => setActivityGraphCampType(e?.value)}
                  />
                </div>
                <div className='card-toolbar align-items-start'>
                  <button type='button' onClick={() => handleDownloadActivityOverview()} className='btn btn-light-primary'>
                    <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
                    Export
                  </button>
                </div>
                </div>
                <div className='card-toolbar align-items-start flex-column'>
                  <ul className='nav nav-tabs activity_tabs' id='myTab' role='tablist'>
                    <li className='nav-item' role='presentation'>
                      <button
                        className='nav-link active'
                        id='Total-tab'
                        data-bs-toggle='tab'
                        data-bs-target='#Total'
                        type='button'
                        role='tab'
                        aria-controls='Total'
                        aria-selected='true'
                        onClick={() => setType('total')}
                      >
                        <span className='symbol-label'>
                          <KTSVG
                            path='/media/icons/duotune/navigationicon/messages.svg'
                            className='svg-icon-2x'
                          />
                        </span>
                        Total
                      </button>
                    </li>
                    <li className='nav-item' role='presentation'>
                      <button
                        className='nav-link'
                        id='Quick-message-tab'
                        data-bs-toggle='tab'
                        data-bs-target='#Quick-message'
                        type='button'
                        role='tab'
                        aria-controls='Quick-message'
                        aria-selected='false'
                        onClick={() => setType('quick')}
                      >
                        <span className='symbol-label'>
                          <KTSVG
                            path='/media/icons/duotune/navigationicon/quick-message.svg'
                            className='svg-icon-2x'
                          />
                        </span>
                        Quick message
                      </button>
                    </li>
                    <li className='nav-item' role='presentation'>
                      <button
                        className='nav-link'
                        id='Bulk-message-tab'
                        data-bs-toggle='tab'
                        data-bs-target='#Bulk-message'
                        type='button'
                        role='tab'
                        aria-controls='Bulk-message'
                        aria-selected='false'
                        onClick={() => setType('bulk')}
                      >
                        <span className='symbol-label'>
                          <KTSVG
                            path='/media/icons/duotune/navigationicon/bulkmsg.svg'
                            className='svg-icon-2x'
                          />
                        </span>
                        Bulk message
                      </button>
                    </li>
                    <li className='nav-item' role='presentation'>
                      <button
                        className='nav-link'
                        id='Review-flow-tab'
                        data-bs-toggle='tab'
                        data-bs-target='#Review-flow'
                        type='button'
                        role='tab'
                        aria-controls='Review-flow'
                        aria-selected='false'
                        onClick={() => setType('review')}
                      >
                        <span className='symbol-label'>
                          <KTSVG
                            path='/media/icons/duotune/navigationicon/medal_star.svg'
                            className='svg-icon-2x'
                          />
                        </span>
                        Review flow
                      </button>
                    </li>
                    <li className='nav-item' role='presentation'>
                      <button
                        className='nav-link'
                        id='Lead-generation-tab'
                        data-bs-toggle='tab'
                        data-bs-target='#Lead-generation'
                        type='button'
                        role='tab'
                        aria-controls='Lead-generation'
                        aria-selected='false'
                        onClick={() => setType('lead')}
                      >
                        <span className='symbol-label'>
                          <KTSVG
                            path='/media/icons/duotune/navigationicon/crown.svg'
                            className='svg-icon-2x'
                          />
                        </span>
                        Lead generation
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div className='card-body px-0 pt-5 tab-content' id='myTabContent'>
                <div
                  className='analytics_charts tab-pane fade show active'
                  id='Total'
                  role='tabpanel'
                  aria-labelledby='Total-tab'
                >
                  <div className='chart_head'>
                    <div className='chart_item'>
                      <strong>{reportCount?.[0]?.campaignMessage || 0}</strong>
                      <span>Bulk message</span>
                      <div className='badge top badge-light-success fw-bold '>
                        <span className='arrow'>
                          <KTSVG path='/media/misc/arrow-up.svg' className='' />
                        </span>
                        4.5%
                      </div>
                    </div>
                    <div className='chart_item'>
                      <strong>{reportCount?.[0]?.totalMessage || 0}</strong>
                      <span>Total messages</span>
                    </div>
                    <div className='chart_item'>
                      <strong>{reportCount?.[0]?.quickMessage || 0}</strong>
                      <span>Quick message</span>
                    </div>
                  </div>
                  {data2?.length > 0 ? (
                    <div className='chart_body'>
                      <ReactApexChart
                        height={300}
                        options={ReviewData.options}
                        series={ReviewData.series}
                        type='area'
                      />
                      {/* <img
                      src={toAbsoluteUrl('/media/misc/activity_overview_chart.svg')}
                      alt='Image'
                      style={{width: '100%'}}
                    /> */}
                    </div>
                  ) : (
                    <NodataYet />
                  )}
                </div>
                <div
                  className='analytics_charts tab-pane fade'
                  id='Quick-message'
                  role='tabpanel'
                  aria-labelledby='Quick-message-tab'
                >
                  <div className='chart_head'>
                    {/* <div className='chart_item'>
                      <strong>2,384</strong>
                      <span>Bulk message</span>
                    </div>
                    <div className='chart_item'>
                      <strong>15,706</strong>
                      <span>Total messages</span>
                    </div> */}
                    <div className='chart_item'>
                      <strong>{reportCount?.[0]?.quickMessage || 0}</strong>
                      <span>Quick message</span>
                    </div>
                  </div>
                  {data2?.length > 0 ? (
                    <div className='chart_body'>
                      <ReactApexChart
                        height={300}
                        options={ReviewData.options}
                        series={ReviewData.series}
                        type='area'
                      />
                      {/* <img
                      src={toAbsoluteUrl('/media/misc/activity_overview_chart.svg')}
                      alt='Image'
                      style={{width: '100%'}}
                    /> */}
                    </div>
                  ) : (
                    <NodataYet />
                  )}
                </div>
                <div
                  className='analytics_charts tab-pane fade'
                  id='Bulk-message'
                  role='tabpanel'
                  aria-labelledby='Bulk-message-tab'
                >
                  <div className='chart_head'>
                    <div className='chart_item'>
                      <strong>{reportCount?.[0]?.campaignMessage || 0}</strong>
                      <span>Bulk message</span>
                    </div>
                    {/* <div className='chart_item'>
                      <strong>10,706</strong>
                      <span>Total messages</span>
                    </div>
                    <div className='chart_item'>
                      <strong>1,035</strong>
                      <span>Quick message</span>
                    </div> */}
                  </div>
                  {data2?.length > 0 ? (
                    <div className='chart_body'>
                      <ReactApexChart
                        height={300}
                        options={ReviewData.options}
                        series={ReviewData.series}
                        type='area'
                      />
                      {/* <img
                      src={toAbsoluteUrl('/media/misc/activity_overview_chart.svg')}
                      alt='Image'
                      style={{width: '100%'}}
                    /> */}
                    </div>
                  ) : (
                    <NodataYet />
                  )}
                </div>
                <div
                  className='analytics_charts tab-pane fade'
                  id='Review-flow'
                  role='tabpanel'
                  aria-labelledby='Review-flow-tab'
                >
                  <div className='chart_head'>
                    <div className='chart_item'>
                      <strong>6,684</strong>
                      <span>Total new leads</span>
                    </div>
                    <div className='chart_item'>
                      <strong>14,706</strong>
                      <span>Manually added</span>
                    </div>
                    <div className='chart_item'>
                      <strong>6,035</strong>
                      <span>Via source</span>
                    </div>
                  </div>
                  <div className='chart_body'>
                    <img
                      src={toAbsoluteUrl('/media/misc/activity_overview_chart.svg')}
                      alt='Image'
                      style={{width: '100%'}}
                    />
                  </div>
                </div>
                <div
                  className='analytics_charts tab-pane fade'
                  id='Lead-generation'
                  role='tabpanel'
                  aria-labelledby='Lead-generation-tab'
                >
                  <div className='chart_head'>
                    <div className='chart_item'>
                      <strong>
                        {' '}
                        {leadgenrationData?.totalCountData?.find(
                          (key: any) => key?._id === 'manually'
                        )?.count || 0}
                      </strong>
                      <span>Total new leads</span>
                    </div>
                    <div className='chart_item'>
                      <strong>
                        {' '}
                        {leadgenrationData?.totalCountData?.find(
                          (key: any) => key?._id === 'manually'
                        )?.count || 0}
                      </strong>
                      <span>Manually added</span>
                    </div>
                    <div className='chart_item'>
                      <strong>0</strong>
                      <span>Via source</span>
                    </div>
                  </div>
                  {leadgenrationData?.contactDataForGraph?.length > 0 ? (
                    <div className='chart_body'>
                      <ReactApexChart
                        height={300}
                        options={leadGenerationData.options}
                        series={leadGenerationData.series}
                        type='area'
                      />
                      {/* <img
                      src={toAbsoluteUrl('/media/misc/activity_overview_chart.svg')}
                      alt='Image'
                      style={{width: '100%'}}
                    /> */}
                    </div>
                  ) : (
                    <NodataYet />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}

      </div>
    </>
  )
}

export default ReportsAnalyticsPage
